import * as React from 'react'

import { classList } from 'react-classlist-helper'

import { LayoutProps } from './types'

export const MobileResourceFilterBar: React.FC<LayoutProps> = ({
  children,
  className,
}) => (
  <div
    className={classList({
      'tw:flex tw:items-center tw:gap-2 tw:px-1.5 tw:py-1.5 tw:border-0 tw:border-b tw:border-solid tw:border-border tw:bg-background': true,
      [className || '']: !!className,
    })}
  >
    {children}
  </div>
)
